export default function (context, value) {
    context.dispatch('settings/open', 'certificates', {root: true});
}